import React, { Component, Fragment } from 'react';
import Modal from 'react-modal';
import Webcam from 'react-webcam';
import { EnableCameraProcess } from './EnableCameraProcess';
import BrowserService from '../services/helper/browserService';

const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);

const isDesktop = !BrowserService.isMobileOrTabled();

export default class ImageUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            file: '',
            imagePreviewUrl: '',
            isWebcamOpen: false,
            isFacingMode: props.isSelfie || false,
            isEnablePermissionsProcessModalOpen: false,
            isEnablePermissionOrUploadFileModalOpen: false,
            devices: [],
            isVideoReady: false,
        };
    }

    openFileInput() {
        this.inputRef.click();
    }
    componentDidMount() {
        Modal.setAppElement('body');

        // iOS doesn't allow access to mediaDevices for "security reasons"
        if (!iOS && window.VULOG_CONFIG && window.VULOG_CONFIG.FORCE_TO_TAKE_PHOTO) {
            if (navigator && navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
                navigator.mediaDevices.enumerateDevices().then(mediaDevices => {
                    return this.setState({ devices: mediaDevices.filter(({ kind }) => kind === 'videoinput') });
                });
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { modalOpeningCount } = this.props;
        if (modalOpeningCount !== prevProps.modalOpeningCount) {
            this.inputRef.click();
        }
    }

    handleSubmit = e => {
        e.preventDefault();
        // TODO: do something with -> this.state.file
    };

    handleImageChange = e => {
        e.preventDefault();

        let reader = new FileReader();
        let file = e.target.files[0];

        if (!file) {
            return;
        }

        if (!this.hasExtension(file.name)) {
            return;
        }

        reader.onloadend = () => {
            this.setState({
                file: file,
                imagePreviewUrl: reader.result,
            });
            this.props.onChange(file);
        };

        reader.readAsDataURL(file);
    };

    triggerFileUpload() {
        const { isMediaDevicesEnabled, modalOpeningCount, requiresPermissionRequest } = this.props;
        // use native input on iOS
        if (iOS) {
            this.inputRef.click();
            return;
        }

        // ANDROID
        // old app, we always trigger input
        if (!requiresPermissionRequest && !isDesktop) {
            this.inputRef.click();
            return;
        }

        // FORCE PHOTO false => User can upload a file or take a photo
        if (!window.VULOG_CONFIG.FORCE_TO_TAKE_PHOTO && !isDesktop) {
            // requiresPermissionRequest
            if (modalOpeningCount > 0 || isMediaDevicesEnabled) {
                // We already opened the modal once, or if user gave access to the cam, no need to display it again
                this.inputRef.click();
                return;
            }
            // We inform the user that he can upload a file, but not take a photo
            this.setState({ isEnablePermissionOrUploadFileModalOpen: true });
            return;
        }

        // If it is a desktop and we don't have the permission to use the camera, we trigger file upload
        if (isDesktop && !isMediaDevicesEnabled) {
            this.inputRef.click();
            return;
        }

        // FORCE PHOTO = true
        if (!isMediaDevicesEnabled) {
            // The user has refused access to camera, we open a modal to explain why he can't continue the process
            this.setState({ isEnablePermissionsProcessModalOpen: true });
            return;
        }
        // the user gave the access to camera, open webcam component
        this.setState({
            isWebcamOpen: true,
        });
    }

    reset() {
        this.setState({
            file: '',
            imagePreviewUrl: '',
        });
        this.inputRef.value = '';
    }

    hasExtension(fileName) {
        return new RegExp('(' + this.props.imageExtension.join('|').replace(/\./g, '\\.') + ')$').test(fileName);
    }

    dataURLtoBlob(dataurl) {
        let arr = dataurl.split(','),
            mime = arr && arr[0].match(/:(.*?);/)[1],
            bstr = arr && atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    }

    takePhoto = () => {
        let screenShot = this.webcam.getScreenshot();
        if (!screenShot) {
            return;
        }
        let file = this.dataURLtoBlob(screenShot);
        this.setState({
            file: file,
            imagePreviewUrl: screenShot,
            isWebcamOpen: false,
            isVideoReady: false,
        });
        this.props.onChange(file);
    };

    closeWebcam = () => {
        const { isSelfie } = this.props;
        this.setState({ isWebcamOpen: false, isFacingMode: isSelfie, isVideoReady: false });
    };

    flipCamera = () => {
        this.setState(prevState => ({ isFacingMode: !prevState.isFacingMode, isVideoReady: false }));
    };

    showContent = () => {
        setTimeout(() => {
            this.setState({ isVideoReady: true });
        }, 300);
    };

    onClosePhotoFalseModal = () => {
        const { onSetModalOpeningCount, modalOpeningCount } = this.props;
        onSetModalOpeningCount(modalOpeningCount + 1);
        this.setState({ isEnablePermissionOrUploadFileModalOpen: false });
    };

    render() {
        let {
            imagePreviewUrl,
            isWebcamOpen,
            isFacingMode,
            isEnablePermissionsProcessModalOpen,
            isEnablePermissionOrUploadFileModalOpen,
            devices,
            isVideoReady,
        } = this.state;
        let $imagePreview = null;
        if (imagePreviewUrl) {
            $imagePreview = <img src={imagePreviewUrl} alt="" key={'imagePreview'} />;
        } else {
            //  $imagePreview = (<img src={this.props.placeholder}/>);
        }
        return [
            <Modal
                isOpen={isWebcamOpen}
                contentLabel="Uploading documents..."
                portalClassName="e-modal"
                overlayClassName="e-modal__overlay e-modal__overlay_webcam"
                className="e-modal__content"
                bodyOpenClassName="e-modal--is-open"
                htmlOpenClassName="prevent-scroll"
                shouldFocusAfterRender={false}
                key={'WebcamModal'}
            >
                <div className="loading-container webcam-container wrapper">
                    {isWebcamOpen && (
                        <Fragment>
                            {isFacingMode || isDesktop ? (
                                <Webcam
                                    className="webcam"
                                    screenshotQuality={1}
                                    screenshotFormat="image/jpeg"
                                    ref={ref => (this.webcam = ref)}
                                    mirrored={isFacingMode}
                                    videoConstraints={{
                                        facingMode: 'user',
                                    }}
                                    hidden={!isVideoReady}
                                    onUserMedia={this.showContent}
                                />
                            ) : (
                                <Webcam
                                    className="webcam"
                                    screenshotQuality={1}
                                    screenshotFormat="image/jpeg"
                                    ref={ref => (this.webcam = ref)}
                                    mirrored={isFacingMode}
                                    videoConstraints={{
                                        facingMode: { exact: 'environment' },
                                    }}
                                    hidden={!isVideoReady}
                                    onUserMedia={this.showContent}
                                />
                            )}
                        </Fragment>
                    )}

                    <div className="container-fluid wrapper webcam-container__btns-wrapper">
                        <button className="btn btn-rounded" onClick={this.closeWebcam}>
                            <i className="material-icons va-middle reg">keyboard_arrow_left</i>
                        </button>
                        <button
                            className="btn btn-rounded btn-rounded-primary btn-rounded-large"
                            onClick={this.takePhoto}
                        >
                            <i className="material-icons va-middle reg">photo_camera</i>
                        </button>
                        {devices.length > 1 && (
                            <button className="btn btn-rounded" onClick={this.flipCamera}>
                                <i className="material-icons va-middle reg">flip_camera_android</i>
                            </button>
                        )}
                    </div>
                </div>
            </Modal>,
            <input
                key={'inputFile-capture'}
                type="file"
                ref={ref => (this.inputRef = ref)}
                onChange={this.handleImageChange}
                style={{ display: 'none' }}
                accept={'image/*'}
                capture={isFacingMode ? 'user' : { exact: 'environment' }}
            />,
            $imagePreview,
            <Modal
                isOpen={
                    !window.VULOG_CONFIG.FORCE_TO_TAKE_PHOTO
                        ? isEnablePermissionOrUploadFileModalOpen
                        : isEnablePermissionsProcessModalOpen
                }
                contentLabel={window.VULOG_TRANSLATE('Need Permission')}
                shouldCloseOnOverlayClick={true}
                shouldCloseOnEsc={true}
                portalClassName="e-modal"
                overlayClassName="e-modal__overlay"
                className="e-modal__content"
                bodyOpenClassName="e-modal--is-open"
                htmlOpenClassName="prevent-scroll"
                shouldFocusAfterRender={false}
                ariaHideApp={false}
                onRequestClose={
                    !window.VULOG_CONFIG.FORCE_TO_TAKE_PHOTO
                        ? () => this.onClosePhotoFalseModal()
                        : () => this.setState({ isEnablePermissionsProcessModalOpen: false })
                }
                key={'enableCameraProcess'}
            >
                {!window.VULOG_CONFIG.FORCE_TO_TAKE_PHOTO ? (
                    <EnableCameraProcess
                        contentType={'EnableCameraOrUploadFile'}
                        onClose={() => this.onClosePhotoFalseModal()}
                    />
                ) : (
                    <EnableCameraProcess
                        onClose={() => this.setState({ isEnablePermissionsProcessModalOpen: false })}
                    />
                )}
            </Modal>,
        ];
    }
}
